import { Icon } from "../icons";
import { Link } from "./link";

/** Props Interface */
interface EmailProps {
	children: string;
	isNullable?: boolean;
}

export function Email({ children, isNullable }: EmailProps) {
	/** Guard */
	if (children === "--") {
		if (isNullable) return null;
		return children;
	}

	/** Computed */
	const href = `mailto:${children}`;

	/** Render */
	return (
		<div className="flex flex-row items-center gap-1">
			<Link
				href={href}
				className="whitespace-nowrap"
			>
				<span className="inline-flex translate-y-[2px] mr-1 opacity-50">
					<Icon name="AtSign" />
				</span>
				{children}
			</Link>
		</div>
	);
}
